import Instance from '../../../Axios';

// New Actions for the app

const GetApartamento = (id) => async (dispatch) => {
  console.log('id', id);
  await Instance()
    .get(`/backend/apartamentos/${id}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_APARTAMENTO', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetApartamento;
